import React, { useEffect } from "react";

const ExternalRedirect = ({ url }) => {
    useEffect(() => {
        window.location.href = url;
    }, [url]);

    return <h5>Redirecting...</h5>
};

export default ExternalRedirect;
